"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductStatus = void 0;
var _react = _interopRequireDefault(require("react"));
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _config = require("../../../config");
var _ProductStatusWrapper = require("../../tableComponents/bodyComponents/ProductStatusWrapper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ProductStatus = function ProductStatus(props) {
  var product = props.product;
  var isProductSold = _config.SHOW_STATUS_OF_PRODUCT_SOLD_WHEN_QUANTITY_0 && product.quantity === 0 && product.status === "published";
  return /*#__PURE__*/_react.default.createElement(_ProductStatusWrapper.ProductStatusWrapper, {
    status: product.status
  }, isProductSold ? /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "vendu",
    defaultMessage: "vendu"
  }) : product.translated_status);
};
exports.ProductStatus = ProductStatus;